import { authRouteConfig } from "./auth";
import Error403 from "./errorPages/Error403";
import React from "react";
import { errorPagesConfigs } from "./errorPages";
import { samplePagesConfigs } from "./sample";
import { bannerConfig } from "./apps/masters/manger_banner";
import { profilePage } from "./profile";
import { userConfig } from "./apps/masters/manger_user";
import { TransactionsConfig } from "./apps/masters/manger_transactions";
import { PolygonConfig } from "./apps/masters/manger_polygon";
import { centreConfig } from "./apps/support";
import { planConfig } from "./apps/planMaster/view_plan";
import { categoryConfig } from "./apps/planMaster/price_plan_category";
import { cmsMasterConfig } from './apps/cmsMaster/cms_page'
import { pageMappingConfig } from "./apps/planMaster/Plan_page_mapping";
import { contactMasterConfig } from "./apps/contactMaster/contact_page";
import { leadMasterConfig } from "./apps/leadMaster/lead_page";
import { syncConfig } from "./apps/syncMaster/sync_data";
import { appellateMasterConfig } from "./apps/AppellateMaster/lead_page";
import { nodelMasterConfig } from "./apps/NodelMaster/lead_page";
import { dashboardConfig } from "./apps/dashboardMaster/dashboard_data";
import { roleMappingConfig } from "./apps/roleMaster/role_data";
import { getInitialUrl } from "shared/constants/AppConst";
import { roleConfig } from "./apps/masters/manger_role";
import { transactionConfig } from "./apps/transactionMaster/transaction_page";
import { CustomerMasterConfig } from "./apps/customerCare/customer_page";
import { investorDeskMasterConfig } from "./apps/investorDeskMaster";
const authorizedStructure = {
  fallbackPath: "/signin",
  unAuthorizedComponent: <Error403 />,
  routes: [...samplePagesConfigs, ...profilePage, ...bannerConfig, ...userConfig, ...TransactionsConfig , ...PolygonConfig , ...centreConfig , ...planConfig ,...categoryConfig ,...pageMappingConfig, ...cmsMasterConfig, ...contactMasterConfig, ...leadMasterConfig, ...syncConfig,...appellateMasterConfig, ...nodelMasterConfig, ...dashboardConfig, ...roleMappingConfig, ...roleConfig,...transactionConfig,...CustomerMasterConfig,...investorDeskMasterConfig],
};

const unAuthorizedStructure = {
   fallbackPath: getInitialUrl(), 
  routes: authRouteConfig,
};

const anonymousStructure = {
  routes: errorPagesConfigs,
};

export { authorizedStructure, unAuthorizedStructure, anonymousStructure };
